import { Button, Dialog, IconButton, Text, Tooltip, Flex } from '@radix-ui/themes';
import { Ban } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const RemoveUserFromOrg = ({
  user,
  loading,
  onSubmit,
}: {
  user: { id: string; firstName: string; lastName: string };
  loading: boolean;
  onSubmit: (user: { id: string }) => Promise<void>;
}) => {
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit(user).then(() => {});
  };

  return (
    <Dialog.Root>
      <Tooltip content={<Text size="3">{t('settings.accessGroupDialogs.removeUserFromOrg.tooltip')}</Text>}>
        <Dialog.Trigger>
          <IconButton variant="ghost" color="gray" highContrast className="m-0">
            <Ban size={20} />
          </IconButton>
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content style={{ maxWidth: 450 }}>
        <Dialog.Title>{t('settings.accessGroupDialogs.removeUserFromOrg.dialogTitle')}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          {t('settings.accessGroupDialogs.removeUserFromOrg.description', {
            userName: `${user.firstName} ${user.lastName}`,
          })}
        </Dialog.Description>

        <Flex gap="3" mt="4" justify="between">
          <Dialog.Close>
            <Button size="3" color="gray" variant="soft">
              {t('settings.accessGroupDialogs.removeUserFromOrg.cancelButton')}
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button size="3" color="red" loading={loading} onClick={handleSubmit}>
              {t('settings.accessGroupDialogs.removeUserFromOrg.removeButton')}
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default RemoveUserFromOrg;
